import React from 'react';

export default function IconBifi({
  size = 24,
  color = '#ff474c',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M12.054 1.528c.287 0 .553.153.696.402l11.144 19.304a.805.805 0 0 1-.696 1.206H.91a.804.804 0 0 1-.697-1.206L11.357 1.93a.804.804 0 0 1 .697-.402ZM2.303 20.832h19.502L12.054 3.94 2.303 20.83Z"
        clipRule="evenodd"
        fill={color}
      />
      <path
        fillRule="evenodd"
        d="M12.043 1.528c.444 0 .805.36.805.804v12.1l10.594 6.357a.804.804 0 0 1-.828 1.38l-10.57-6.343-10.572 6.343a.804.804 0 1 1-.828-1.38l10.595-6.357v-12.1c0-.444.36-.804.804-.804Z"
        clipRule="evenodd"
        fill={color}
      />
    </svg>
  );
}
